import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Angular's own Router is unused for real navigation (UI-Router owns all app routing - see
// project-overview.md); this catch-all keeps it from throwing "Cannot match any routes" every
// time UI-Router changes the URL, since both routers share the same Location service.
const routes: Routes = [
  { path: '**', children: [] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
